// App is completed Congratulations
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import About from "./components/About";
import React, {useState} from "react";
import NoteState from "./context/notes/NoteState";
import Alert from "./components/Alert";
import Login from "./components/Login";
import Signup from "./components/Signup";
import GlobalNotes from "./components/GlobalNotes";
function App() {
  const [alert, setAlert] = useState(null); // alert is an object
  const [token, settoken] = useState();
  const showAlert =(message, type)=>{
    setAlert({
      msg: message,
      type: type
    })
    setTimeout(() => {
      setAlert(null);
    }, 3000);
  }
  return (
    <>
      <NoteState>
        {/*Wrapping all components inside NoteState so that they can all use its state varibales */}
        <Router>
          <Navbar token={token} settoken={settoken} />
          <Alert alert={alert}/>
          <div className="container">
            {localStorage.getItem('token')==null?
            <Routes>
              <Route exact path="/login" element={<Login showAlert={showAlert}/>} />
              <Route path="*" element={<Signup showAlert={showAlert}/>} />
            </Routes>
            :
            <Routes>
              <Route exact path="/" element={<Home showAlert={showAlert}/>} />
              <Route exact path="/about" element={<About />} />
              <Route exact path="/globalnotes" element={<GlobalNotes/>} />
              <Route exact path="/login" element={<Login showAlert={showAlert}/>} />
              <Route exact path="/signup" element={<Signup showAlert={showAlert}/>} />
              <Route exact path="*" element={<Home showAlert={showAlert}/>} />
            </Routes>
            }
            
          </div>
        </Router>
      </NoteState>
    </>
  );
}

export default App;
